import axios from 'axios';
import { LocalizationIds } from 'helpers/Localizations';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';


interface IContext {
    isOpen: boolean
    isSaving: boolean
    isSearching: boolean
    isSearchDone: boolean
    search: string
    count: number
    tickets: ITicket[]
    selectedTicket?: ITicket

    chooseTicket: (ticket: ITicket) => void
    updateSearch: (value: string) => void
    moveMessage: () => Promise<void>
    searchTickets: () => Promise<void>
    open: () => void
    close: () => void
}

interface ITicket {
    id: string
    ticketNumber: string
    title: string
    customerName: string
}

export let moveMessageContext = React.createContext({} as IContext);

let { Provider } = moveMessageContext;

let MoveMessageProvider: React.FC<{ children: React.ReactNode, messageId: string }> = ({ children, messageId }) => {
    let { formatMessage } = useIntl();
    let history = useHistory();

    let [isOpen, setOpen] = useState(false);
    let [isSaving, setSaving] = useState(false);

    let [isSearching, setSearching] = useState(false);
    let [isSearchDone, setSearchDone] = useState(false);

    let [search, setSearch] = useState('');
    let [selectedTicket, setSelectedTicket] = useState<ITicket>();

    let [tickets, setTickets] = useState<ITicket[]>([]);
    let [count, setCount] = useState<number>(0);


    let open = () => {
        setOpen(true);
    }

    let close = () => {
        setOpen(false);
        setSearchDone(false);
        setTickets([]);
        setSelectedTicket(undefined);
        setSearch('')
    }

    let chooseTicket = (ticket: ITicket) => {
        setSelectedTicket(ticket);
    }

    let searchTickets = async () => {
        try {
            setSearching(true);
            setSearchDone(false);

            let res = await axios.get('/api/Ticket/QuickSearchTickets', { params: { searchRequest: search } });
            setTickets(res.data.items);
            setCount(res.data.recordCount);
            setSearchDone(true);

        } catch (err) {
        } finally {
            setSearching(false);
        }
    }

    let moveMessage = async () => {
        try {
            if (window.confirm(formatMessage({ id: LocalizationIds.INFO_MoveMessageToTicket })) === false)
                return;

            setSaving(true);

            let request = {
                messageId,
                ticketId: selectedTicket?.id
            }

            let res = await axios.post('/api/TicketMessage/MoveMessageToTicket', request);
            history.push(`/ticket/edit/${res.data.stringId}`);

        } catch (err) {
            setSaving(false);
        }
    }

    let updateSearch = (value: string) => {
        setSearch(value);
    }


    return (
        <Provider
            value={{
                isOpen,
                isSaving,
                isSearching,
                isSearchDone,
                search,
                count,
                tickets,
                selectedTicket,

                open,
                close,
                chooseTicket,
                updateSearch,
                moveMessage,
                searchTickets
            }}
        >
            {children}
        </Provider>
    )
}

export default MoveMessageProvider;